import { Config } from '@/util/Config';
import { initGA4, initGoogleTagManager } from '@/initGoogleTagManager';

export function fetchGA4() {
  try {
    const topmostScriptElement = document.getElementsByTagName('script')[0];
    const scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.src = 'https://www.googletagmanager.com/gtag/js?id=' + Config.GA4_ID;
    topmostScriptElement?.parentNode?.insertBefore(scriptElement, topmostScriptElement);
    initGA4();
  } catch(e) {
      // tslint:disable:no-console
      console.trace(e);
  }
}

export function fetchGoogleTagManager() {
    try {
        const topmostScriptElement = document.getElementsByTagName('script')[0];
        const scriptElement = document.createElement('script');
        scriptElement.async = true;
        scriptElement.src = 'https://www.googletagmanager.com/gtm.js?id=' + Config.GTM_CONTAINER_ID;
        topmostScriptElement?.parentNode?.insertBefore(scriptElement, topmostScriptElement);
        initGoogleTagManager();
    } catch(e) {
        // tslint:disable:no-console
        console.trace(e);
    }
}
